import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Container, Grid } from 'semantic-ui-react';
import { goBack } from 'connected-react-router';

import { HeaderComponent } from '../components/HeaderComponent';
import { NavBar } from '../components/NavBar';
import { ProjectCreateComponent } from '../components/project/ProjectCreateComponent';
import { TranslationComponent } from '../components/TranslationComponent';

interface ProjectCreateSceneProps extends Component {
  goBack: typeof goBack;
}

class PProjectCreateScene extends Component<ProjectCreateSceneProps> {
  render() {
    const { goBack } = this.props;

    return (
      <React.Fragment>
        <HeaderComponent />
        <NavBar />
        <Container fluid>
          <Grid>
            <Grid.Row>
              <Grid.Column floated="left" textAlign="center" width={2}>
                <Button primary onClick={goBack}>
                  <TranslationComponent stringKey={'Back'} />
                </Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <ProjectCreateComponent />
        </Container>
      </React.Fragment>
    );
  }
}

export const ProjectCreateScene = connect(null, { goBack })(PProjectCreateScene);
